import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useScheduleStore = defineStore('schedule', {
  state: createInitialState,
  actions,
  getters,
})
